import { Space, Switch, Table, Typography } from 'antd';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import {
	CopyIcon,
	DeleteActionSvg,
	EditActionSvg,
	LockIcon
} from 'utils/svgs';
import { checkPermission } from 'utils/utils';
import SearchAndFilter from '../SearchAndFilter';
import styles from './index.module.scss';
import './index.scss';
import { CustomTableProps } from './type';

const { Text } = Typography;


const CustomTable: FC<CustomTableProps> = (props) => {
	const { Column } = Table;
	const {
		roleDataSource,
		performSearchHandler,
		performFilterHandler,
		searchValue,
		// filterValue,
		setDrawerInfoHandler,
		openPermissionsHandler,
		fetchRolePermissions,
		// paginationChangeHandler,
		// totalRecords,
		// currentPage,
		performSortHandler,
		// PageSize,
		// modifyPageSize,
		sortDirection,
		isLoading,
		openDrawerHandler,
		showModal,
		setEditSelectedRole,
		setIsCopyRole,
		updateStatusHanler
	} = props;

	const userPermission = useSelector(
		(state: any) => state?.userProfile?.data
	);
	// Handle permissions action
	const permissionsHandler = () => {
		openPermissionsHandler();
		setDrawerInfoHandler('Permission Details');
	};

	const isEditPermission = checkPermission(userPermission?.permissions, {
		permissionName: 'Roles',
		permission: ['edit'],
	});

	const isDeletePermission = checkPermission(userPermission?.permissions, {
		permissionName: 'Roles',
		permission: ['delete'],
	});
	const isAddPermission = checkPermission(userPermission?.permissions, {
		permissionName: 'Roles',
		permission: ['add'],
	});

	// For handle the table change click
	const tableChangeHandler = (d1: any, d2: any, data: any) => {
		performSortHandler && performSortHandler(data.order, d1.current);
	};

	const editDataHandler = (roleObject: any) => {
		openDrawerHandler();
		setDrawerInfoHandler('Edit Role');
		setEditSelectedRole(roleObject);
	};

	const deleteDataHandler = (roleObject: any) => {
		setEditSelectedRole(roleObject);
		showModal();
	};

	const copyDataHandler = (roleObject: any) => {
		const updatedRoleObject = {
			...roleObject,
			roleName: `Copy of ${roleObject?.roleName ?? ''}`
		};
		openDrawerHandler();
		setDrawerInfoHandler('Copy Role');
		setEditSelectedRole(updatedRoleObject);
		setIsCopyRole(true)
	};

	return (
		<div className={`${styles['body']} role-table`}>
			<SearchAndFilter
				performSearchHandler={performSearchHandler}
				searchValue={searchValue}
				filterValue=''
				performFilterHandler={performFilterHandler}
				title='Role List'
				openDrawerHandler={() => {
					openDrawerHandler();
					setDrawerInfoHandler('Add Role');
				}}
			/>
			<Table
				rowKey={(record: any) => record?.roleName}
				dataSource={roleDataSource}
				pagination={false}
				loading={isLoading}
				onChange={tableChangeHandler}
				scroll={{ y: 'calc(100vh - 200px)' }}
			>
				<Column
					showSorterTooltip={{ title: '' }}
					defaultSortOrder={sortDirection}
					title={() => {
						return <>Role Name</>;
					}}
					dataIndex="roleName"
					key="roleName"
					width={'15%'}
					sortDirections={['ascend', 'descend', 'ascend']}
					className="bg-white"
				/>
				<Column
					title="Description"
					dataIndex="roleDescription"
					key="roleDescription"
					width={'25%'}
					className="bg-white"
				/>
				<Column
					title="Status"
					dataIndex="status"
					key="Status"
					width={'15%'}
					className="bg-white"
					render={(_, data: any, index: any) => {
						return <>
							<Switch
								defaultChecked={data.status}
								disabled={
									!isEditPermission ||
									(data.isAdmin && !userPermission?.isSuperAdmin) ||
									userPermission?.roleId === data.id
								}
								onChange={(e) => { updateStatusHanler(e, data) }}
							/>
						</>
					}}
				/>
				<Column
					title="Permissions"
					dataIndex="permissions"
					key="permissions"
					className="bg-white"
					width={'25%'}
					render={(_, data: any, index: any) => (
						<>
							{isEditPermission &&
								(!data.isAdmin || userPermission?.isSuperAdmin) &&
								userPermission?.roleId !== data.id ? (
								<div
									onClick={() => fetchRolePermissions!(data)}
								>
									<LockIcon />
									<Text
										underline
										onClick={permissionsHandler}
										className={
											styles['dynamic-table__permissions']
										}
									>
										Edit  Permissions
									</Text>
								</div>
							) : (

								<div
									className={
										styles['dynamic-table__no-permissions']
									}
									onClick={() => fetchRolePermissions!(data)}
								>
									<LockIcon />
									<Text
										underline
										className={`${styles['dynamic-table__no-permissions--margin-left']}`}
									>
										Edit	Permissions
									</Text>
								</div>
							)}
						</>
					)}
				/>

				{(isEditPermission || isDeletePermission) && (
					<Column
						title="Action"
						dataIndex="action"
						key="Action"
						width={'25%'}
						className="bg-white"
						render={(value, data: any) => {
							return (
								<Space size={20}>
									{isEditPermission &&
										(!data.isAdmin || userPermission?.isSuperAdmin) &&
										userPermission?.roleId !== data.id
										? (
											<div
												className="cursor-pointer flex align-center justify-center rounded-action-btn"
												onClick={() =>
													editDataHandler(data)
												}
											>
												<EditActionSvg />
											</div>
										) : (
											<div className="cursor-not-allowed flex align-center justify-center rounded-action-btn "
												style={{ opacity: 0.5 }}
											>
												<EditActionSvg />
											</div>
										)}

									{isDeletePermission &&
										(!data.isAdmin || userPermission?.isSuperAdmin) &&
										userPermission?.roleId !== data.id
										? (
											<div
												className="cursor-pointer flex align-center justify-center rounded-action-btn "
												onClick={() =>
													deleteDataHandler(data)
												}
											>
												<DeleteActionSvg />
											</div>
										) : (
											<div className=" cursor-not-allowed flex align-center justify-center rounded-action-btn "
												style={{ opacity: 0.5 }}>
												<DeleteActionSvg />
											</div>
										)}

									{isAddPermission && <div
										className="cursor-pointer flex align-center justify-center  "
										onClick={() =>
											copyDataHandler(data)
										}
									>
										<CopyIcon />
									</div>}
									{/* {data.invitationStatus === 'Pending' && (
									<Tooltip title="Reinvite">
										<div
											className="cursor-pointer flex align-center justify-center rounded-action-btn "
											onClick={() => {
												reinviteUserAction(data);
											}}
										>
											<MailOutlined />
										</div>
									</Tooltip>
								)} */}
								</Space>
							);
						}}
					/>
				)}

			</Table>
		</div>
	);
};

export default CustomTable;
